/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { transLabel } from 'aegion_common_utilities/lib/LabelTransform';

import { AimButtonLink, BL_TYPES } from '../../../../../../../../commons/components/AimButtons';
import LoadingMessage from './LoadingMessage';
import HistoryDetails from './HistoryDetails';

const ModalForceDelete = ({
	item,
	show,
	close,
	isLoading,
	historyDetails,
	isDeleting,
	deleteItem
 }) => { 
	const {
		disabled,
		saveIconCss,
	} = useMemo(() => ({
		disabled: isDeleting,
		saveIconCss: isDeleting ? 'fa fa-spinner fa-spin' : 'fa',
	}), [isDeleting]);

	const forceDelete = useCallback(() => { 
		if (!isDeleting) { 
			deleteItem(item, { forceDelete: true });
		}
	}, [item, isDeleting, deleteItem])

	return (
		<>
			<Modal
				backdrop
				show={show}
				onHide={close}
				bsSize="large"
				className='scanline-wrapper-modal-create-customer-job'
				backdropClassName="scanline-backdrop-modal-create-customer-job"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						Warning: This is tied to user data.<br/>
						<small>Details Below</small>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{isLoading ? (<LoadingMessage />) : null}
					{historyDetails ? (<HistoryDetails historyDetails={historyDetails} />) : null}
					
				</Modal.Body>
				<Modal.Footer>
					<div className='simple-flex'>
						<div className='col-grow'>
							<AimButtonLink blType="BUTTON" bsStyle="default" className="outline" onClick={close}>
								Cancel
							</AimButtonLink>
						</div>
						<div className='col-static'>
							<AimButtonLink onClick={forceDelete} blType={BL_TYPES.ICON_BUTTON} bsStyle="warning" disabled={disabled} iconClassname={saveIconCss}>
								Force Delete Line & Data
							</AimButtonLink>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default ModalForceDelete;